import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

export default function About() {
    const { t } = useTranslation();
    const notices = [
        {
            title: t("TailoringCourse"),
            date: "Ongoing Registrations",
            details: "Click Here to Apply",
           link: "/tailoring-form"
        },

        {
            title: t("SoftwareCourse"),
            date: "Ongoing Registrations",
            details: "Click Here to Apply",
            link: '/courses/sdc-register'

        },
        {
            title: t("EmbroideryCourse"),
            date: "Ongoing Registrations",
            details:"Click Here to Apply",
            link: '/aari-form'
        },

    ];

    const navigate = useNavigate();
    const navigateToAboutUs = () => {
        navigate("/aboutus");
    };

    return (
        <>
            <div className="aboutus_bg_content">
                <div className="aboutus-content">
                    <Container>
                        <Row style={{ margin: '0' }}>
                            <Col sm={12} md={12} lg={6}>
                                <div className="main-content">
                                    {/* <div className="main-heading">
                                        <p>ABOUT US</p>
                                    </div> */}
                                    <div className="welcome-heading">
                                        <h2 style={{ color: '#e69d00' }}>About Us</h2>
                                       
                                    </div>
                                    <div className="about-para">
                                        <p style={{ fontFamily: "Roboto", fontSize: '16px' }}>{t("AboutUsContent")}</p>
                                        <h4 style={{ fontWeight: 'bold' }}>
                                            {t("OurMission")}
                                        </h4>
                                        <ul style={{ fontSize: '16px', lineHeight: '1.9' }}>
                                            <li dangerouslySetInnerHTML={{ __html: t("Mission1") }}></li>
                                            <li dangerouslySetInnerHTML={{ __html: t("Mission2") }}></li>
                                            <li dangerouslySetInnerHTML={{ __html: t("Mission3") }}></li>
                                        </ul>
                                        {/* <span className="read-more" onClick={navigateToAboutUs}>
                                                <b>மேலும் படிக்க ▶</b>
                                            </span> */}
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12} md={12} lg={6} className="d-flex justify-content-center align-items-start">
                                <div className="notice-board" style={{ padding: '20px', borderRadius: '20px',height:'320px' }}>
                                    <h3 style={{ color: '#e69d00' }}><i className="fa-solid fa-bullhorn"></i> NOTICES</h3>
                                    <div className="notices-list" style={{overflow:'visible'}}>
                                        {notices.map((notice, index) => (
                                            <div className="notice-item" key={index}>
                                                <h4>{notice.title}  - {notice.date} </h4>
                                                {notice.link ? (
                                                    <Link to={notice.link} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>
                                                        {notice.details}
                                                    </Link>
                                                ) : (
                                                    <Link onClick={notice.action} style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}>
                                                        {notice.details}
                                                    </Link>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>


        </>
    )
}